// extracted by css-extract-rspack-plugin
export default {"basicPaginatorClusterLayout":"basicPaginatorClusterLayout-3TzXt"};